import * as React from 'react';

const ScreenSmallFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="screen-small-fill_svg__24_small_screen_small_fill-a"
                d="M11 15H1V3h10v12zm-6 3v-1h2v1H5zM0 0v20h12V0H0z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(6 2)">
            <mask
                id="screen-small-fill_svg__24_small_screen_small_fill-b"
                fill="#fff"
            >
                <use xlinkHref="#screen-small-fill_svg__24_small_screen_small_fill-a" />
            </mask>
            <use
                fill="#45494E"
                xlinkHref="#screen-small-fill_svg__24_small_screen_small_fill-a"
            />
            <g mask="url(#screen-small-fill_svg__24_small_screen_small_fill-b)">
                <path fill="#000" d="M-6-2h24v24H-6z" />
            </g>
        </g>
    </svg>
);

ScreenSmallFillSvg.displayName = 'ScreenSmallFillSvg';
export default ScreenSmallFillSvg;
